module.exports = __webpack_public_path__ + "img/34.f8540283.jpg";